

















import Vue from 'vue';
import BaseButton from './BaseButton.vue';
import { mapState as mapRootState } from 'vuex';

export default Vue.extend({
    components: { BaseButton },
    props: {
        title: {
            type: String,
            default: '',
        },
        label: {
            type: String,
            default: 'label',
        },
        size: {
            type: String,
            default: 'big',
        },
        type: {
            type: String,
            default: 'button',
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        ...mapRootState(['portalBranding']),
    },
});
